function createCountry(name, code, emoji, unicode) {
  return {
    name,
    code,
    emoji,
    unicode,
    image: `https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/${code}.svg`,
  };
}

export const countries = [
  createCountry("Ascension Island", "AC", "🇦🇨", "U+1F1E6 U+1F1E8"),
  createCountry("Andorra", "AD", "🇦🇩", "U+1F1E6 U+1F1E9"),
  createCountry("United Arab Emirates", "AE", "🇦🇪", "U+1F1E6 U+1F1EA"),
  createCountry("Afghanistan", "AF", "🇦🇫", "U+1F1E6 U+1F1EB"),
  createCountry("Antigua & Barbuda", "AG", "🇦🇬", "U+1F1E6 U+1F1EC"),
  createCountry("Anguilla", "AI", "🇦🇮", "U+1F1E6 U+1F1EE"),
  createCountry("Albania", "AL", "🇦🇱", "U+1F1E6 U+1F1F1"),
  createCountry("Armenia", "AM", "🇦🇲", "U+1F1E6 U+1F1F2"),
  createCountry("Angola", "AO", "🇦🇴", "U+1F1E6 U+1F1F4"),
  createCountry("Antarctica", "AQ", "🇦🇶", "U+1F1E6 U+1F1F6"),
  createCountry("Argentina", "AR", "🇦🇷", "U+1F1E6 U+1F1F7"),
  createCountry("American Samoa", "AS", "🇦🇸", "U+1F1E6 U+1F1F8"),
  createCountry("Austria", "AT", "🇦🇹", "U+1F1E6 U+1F1F9"),
  createCountry("Australia", "AU", "🇦🇺", "U+1F1E6 U+1F1FA"),
  createCountry("Aruba", "AW", "🇦🇼", "U+1F1E6 U+1F1FC"),
  createCountry("Åland Islands", "AX", "🇦🇽", "U+1F1E6 U+1F1FD"),
  createCountry("Azerbaijan", "AZ", "🇦🇿", "U+1F1E6 U+1F1FF"),
  createCountry("Bosnia & Herzegovina", "BA", "🇧🇦", "U+1F1E7 U+1F1E6"),
  createCountry("Barbados", "BB", "🇧🇧", "U+1F1E7 U+1F1E7"),
  createCountry("Bangladesh", "BD", "🇧🇩", "U+1F1E7 U+1F1E9"),
  createCountry("Belgium", "BE", "🇧🇪", "U+1F1E7 U+1F1EA"),
  createCountry("Burkina Faso", "BF", "🇧🇫", "U+1F1E7 U+1F1EB"),
  createCountry("Bulgaria", "BG", "🇧🇬", "U+1F1E7 U+1F1EC"),
  createCountry("Bahrain", "BH", "🇧🇭", "U+1F1E7 U+1F1ED"),
  createCountry("Burundi", "BI", "🇧🇮", "U+1F1E7 U+1F1EE"),
  createCountry("Benin", "BJ", "🇧🇯", "U+1F1E7 U+1F1EF"),
  createCountry("St. Barthélemy", "BL", "🇧🇱", "U+1F1E7 U+1F1F1"),
  createCountry("Bermuda", "BM", "🇧🇲", "U+1F1E7 U+1F1F2"),
  createCountry("Brunei", "BN", "🇧🇳", "U+1F1E7 U+1F1F3"),
  createCountry("Bolivia", "BO", "🇧🇴", "U+1F1E7 U+1F1F4"),
  createCountry("Caribbean Netherlands", "BQ", "🇧🇶", "U+1F1E7 U+1F1F6"),
  createCountry("Brazil", "BR", "🇧🇷", "U+1F1E7 U+1F1F7"),
  createCountry("Bahamas", "BS", "🇧🇸", "U+1F1E7 U+1F1F8"),
  createCountry("Bhutan", "BT", "🇧🇹", "U+1F1E7 U+1F1F9"),
  createCountry("Bouvet Island", "BV", "🇧🇻", "U+1F1E7 U+1F1FB"),
  createCountry("Botswana", "BW", "🇧🇼", "U+1F1E7 U+1F1FC"),
  createCountry("Belarus", "BY", "🇧🇾", "U+1F1E7 U+1F1FE"),
  createCountry("Belize", "BZ", "🇧🇿", "U+1F1E7 U+1F1FF"),
  createCountry("Canada", "CA", "🇨🇦", "U+1F1E8 U+1F1E6"),
  createCountry("Cocos (Keeling) Islands", "CC", "🇨🇨", "U+1F1E8 U+1F1E8"),
  createCountry("Congo - Kinshasa", "CD", "🇨🇩", "U+1F1E8 U+1F1E9"),
  createCountry("Central African Republic", "CF", "🇨🇫", "U+1F1E8 U+1F1EB"),
  createCountry("Congo - Brazzaville", "CG", "🇨🇬", "U+1F1E8 U+1F1EC"),
  createCountry("Switzerland", "CH", "🇨🇭", "U+1F1E8 U+1F1ED"),
  createCountry("Côte d'Ivoire", "CI", "🇨🇮", "U+1F1E8 U+1F1EE"),
  createCountry("Cook Islands", "CK", "🇨🇰", "U+1F1E8 U+1F1F0"),
  createCountry("Chile", "CL", "🇨🇱", "U+1F1E8 U+1F1F1"),
  createCountry("Cameroon", "CM", "🇨🇲", "U+1F1E8 U+1F1F2"),
  createCountry("China", "CN", "🇨🇳", "U+1F1E8 U+1F1F3"),
  createCountry("Colombia", "CO", "🇨🇴", "U+1F1E8 U+1F1F4"),
  createCountry("Clipperton Island", "CP", "🇨🇵", "U+1F1E8 U+1F1F5"),
  createCountry("Costa Rica", "CR", "🇨🇷", "U+1F1E8 U+1F1F7"),
  createCountry("Cuba", "CU", "🇨🇺", "U+1F1E8 U+1F1FA"),
  createCountry("Cape Verde", "CV", "🇨🇻", "U+1F1E8 U+1F1FB"),
  createCountry("Curaçao", "CW", "🇨🇼", "U+1F1E8 U+1F1FC"),
  createCountry("Christmas Island", "CX", "🇨🇽", "U+1F1E8 U+1F1FD"),
  createCountry("Cyprus", "CY", "🇨🇾", "U+1F1E8 U+1F1FE"),
  createCountry("Czechia", "CZ", "🇨🇿", "U+1F1E8 U+1F1FF"),
  createCountry("Germany", "DE", "🇩🇪", "U+1F1E9 U+1F1EA"),
  createCountry("Diego Garcia", "DG", "🇩🇬", "U+1F1E9 U+1F1EC"),
  createCountry("Djibouti", "DJ", "🇩🇯", "U+1F1E9 U+1F1EF"),
  createCountry("Denmark", "DK", "🇩🇰", "U+1F1E9 U+1F1F0"),
  createCountry("Dominica", "DM", "🇩🇲", "U+1F1E9 U+1F1F2"),
  createCountry("Dominican Republic", "DO", "🇩🇴", "U+1F1E9 U+1F1F4"),
  createCountry("Algeria", "DZ", "🇩🇿", "U+1F1E9 U+1F1FF"),
  createCountry("Ceuta & Melilla", "EA", "🇪🇦", "U+1F1EA U+1F1E6"),
  createCountry("Ecuador", "EC", "🇪🇨", "U+1F1EA U+1F1E8"),
  createCountry("Estonia", "EE", "🇪🇪", "U+1F1EA U+1F1EA"),
  createCountry("Egypt", "EG", "🇪🇬", "U+1F1EA U+1F1EC"),
  createCountry("Western Sahara", "EH", "🇪🇭", "U+1F1EA U+1F1ED"),
  createCountry("Eritrea", "ER", "🇪🇷", "U+1F1EA U+1F1F7"),
  createCountry("Spain", "ES", "🇪🇸", "U+1F1EA U+1F1F8"),
  createCountry("Ethiopia", "ET", "🇪🇹", "U+1F1EA U+1F1F9"),
  createCountry("European Union", "EU", "🇪🇺", "U+1F1EA U+1F1FA"),
  createCountry("Finland", "FI", "🇫🇮", "U+1F1EB U+1F1EE"),
  createCountry("Fiji", "FJ", "🇫🇯", "U+1F1EB U+1F1EF"),
  createCountry("Falkland Islands", "FK", "🇫🇰", "U+1F1EB U+1F1F0"),
  createCountry("Micronesia", "FM", "🇫🇲", "U+1F1EB U+1F1F2"),
  createCountry("Faroe Islands", "FO", "🇫🇴", "U+1F1EB U+1F1F4"),
  createCountry("France", "FR", "🇫🇷", "U+1F1EB U+1F1F7"),
  createCountry("Gabon", "GA", "🇬🇦", "U+1F1EC U+1F1E6"),
  createCountry("United Kingdom", "GB", "🇬🇧", "U+1F1EC U+1F1E7"),
  createCountry("Grenada", "GD", "🇬🇩", "U+1F1EC U+1F1E9"),
  createCountry("Georgia", "GE", "🇬🇪", "U+1F1EC U+1F1EA"),
  createCountry("French Guiana", "GF", "🇬🇫", "U+1F1EC U+1F1EB"),
  createCountry("Guernsey", "GG", "🇬🇬", "U+1F1EC U+1F1EC"),
  createCountry("Ghana", "GH", "🇬🇭", "U+1F1EC U+1F1ED"),
  createCountry("Gibraltar", "GI", "🇬🇮", "U+1F1EC U+1F1EE"),
  createCountry("Greenland", "GL", "🇬🇱", "U+1F1EC U+1F1F1"),
  createCountry("Gambia", "GM", "🇬🇲", "U+1F1EC U+1F1F2"),
  createCountry("Guinea", "GN", "🇬🇳", "U+1F1EC U+1F1F3"),
  createCountry("Guadeloupe", "GP", "🇬🇵", "U+1F1EC U+1F1F5"),
  createCountry("Equatorial Guinea", "GQ", "🇬🇶", "U+1F1EC U+1F1F6"),
  createCountry("Greece", "GR", "🇬🇷", "U+1F1EC U+1F1F7"),
  createCountry(
    "South Georgia & South Sandwich Islands",
    "GS",
    "🇬🇸",
    "U+1F1EC U+1F1F8"
  ),
  createCountry("Guatemala", "GT", "🇬🇹", "U+1F1EC U+1F1F9"),
  createCountry("Guam", "GU", "🇬🇺", "U+1F1EC U+1F1FA"),
  createCountry("Guinea-Bissau", "GW", "🇬🇼", "U+1F1EC U+1F1FC"),
  createCountry("Guyana", "GY", "🇬🇾", "U+1F1EC U+1F1FE"),
  createCountry("Hong Kong SAR China", "HK", "🇭🇰", "U+1F1ED U+1F1F0"),
  createCountry("Heard & McDonald Islands", "HM", "🇭🇲", "U+1F1ED U+1F1F2"),
  createCountry("Honduras", "HN", "🇭🇳", "U+1F1ED U+1F1F3"),
  createCountry("Croatia", "HR", "🇭🇷", "U+1F1ED U+1F1F7"),
  createCountry("Haiti", "HT", "🇭🇹", "U+1F1ED U+1F1F9"),
  createCountry("Hungary", "HU", "🇭🇺", "U+1F1ED U+1F1FA"),
  createCountry("Canary Islands", "IC", "🇮🇨", "U+1F1EE U+1F1E8"),
  createCountry("Indonesia", "ID", "🇮🇩", "U+1F1EE U+1F1E9"),
  createCountry("Ireland", "IE", "🇮🇪", "U+1F1EE U+1F1EA"),
  createCountry("Israel", "IL", "🇮🇱", "U+1F1EE U+1F1F1"),
  createCountry("Isle of Man", "IM", "🇮🇲", "U+1F1EE U+1F1F2"),
  createCountry("India", "IN", "🇮🇳", "U+1F1EE U+1F1F3"),
  createCountry(
    "British Indian Ocean Territory",
    "IO",
    "🇮🇴",
    "U+1F1EE U+1F1F4"
  ),
  createCountry("Iraq", "IQ", "🇮🇶", "U+1F1EE U+1F1F6"),
  createCountry("Iran", "IR", "🇮🇷", "U+1F1EE U+1F1F7"),
  createCountry("Iceland", "IS", "🇮🇸", "U+1F1EE U+1F1F8"),
  createCountry("Italy", "IT", "🇮🇹", "U+1F1EE U+1F1F9"),
  createCountry("Jersey", "JE", "🇯🇪", "U+1F1EF U+1F1EA"),
  createCountry("Jamaica", "JM", "🇯🇲", "U+1F1EF U+1F1F2"),
  createCountry("Jordan", "JO", "🇯🇴", "U+1F1EF U+1F1F4"),
  createCountry("Japan", "JP", "🇯🇵", "U+1F1EF U+1F1F5"),
  createCountry("Kenya", "KE", "🇰🇪", "U+1F1F0 U+1F1EA"),
  createCountry("Kyrgyzstan", "KG", "🇰🇬", "U+1F1F0 U+1F1EC"),
  createCountry("Cambodia", "KH", "🇰🇭", "U+1F1F0 U+1F1ED"),
  createCountry("Kiribati", "KI", "🇰🇮", "U+1F1F0 U+1F1EE"),
  createCountry("Comoros", "KM", "🇰🇲", "U+1F1F0 U+1F1F2"),
  createCountry("St. Kitts & Nevis", "KN", "🇰🇳", "U+1F1F0 U+1F1F3"),
  createCountry("North Korea", "KP", "🇰🇵", "U+1F1F0 U+1F1F5"),
  createCountry("South Korea", "KR", "🇰🇷", "U+1F1F0 U+1F1F7"),
  createCountry("Kuwait", "KW", "🇰🇼", "U+1F1F0 U+1F1FC"),
  createCountry("Cayman Islands", "KY", "🇰🇾", "U+1F1F0 U+1F1FE"),
  createCountry("Kazakhstan", "KZ", "🇰🇿", "U+1F1F0 U+1F1FF"),
  createCountry("Laos", "LA", "🇱🇦", "U+1F1F1 U+1F1E6"),
  createCountry("Lebanon", "LB", "🇱🇧", "U+1F1F1 U+1F1E7"),
  createCountry("St. Lucia", "LC", "🇱🇨", "U+1F1F1 U+1F1E8"),
  createCountry("Liechtenstein", "LI", "🇱🇮", "U+1F1F1 U+1F1EE"),
  createCountry("Sri Lanka", "LK", "🇱🇰", "U+1F1F1 U+1F1F0"),
  createCountry("Liberia", "LR", "🇱🇷", "U+1F1F1 U+1F1F7"),
  createCountry("Lesotho", "LS", "🇱🇸", "U+1F1F1 U+1F1F8"),
  createCountry("Lithuania", "LT", "🇱🇹", "U+1F1F1 U+1F1F9"),
  createCountry("Luxembourg", "LU", "🇱🇺", "U+1F1F1 U+1F1FA"),
  createCountry("Latvia", "LV", "🇱🇻", "U+1F1F1 U+1F1FB"),
  createCountry("Libya", "LY", "🇱🇾", "U+1F1F1 U+1F1FE"),
  createCountry("Morocco", "MA", "🇲🇦", "U+1F1F2 U+1F1E6"),
  createCountry("Monaco", "MC", "🇲🇨", "U+1F1F2 U+1F1E8"),
  createCountry("Moldova", "MD", "🇲🇩", "U+1F1F2 U+1F1E9"),
  createCountry("Montenegro", "ME", "🇲🇪", "U+1F1F2 U+1F1EA"),
  createCountry("St. Martin", "MF", "🇲🇫", "U+1F1F2 U+1F1EB"),
  createCountry("Madagascar", "MG", "🇲🇬", "U+1F1F2 U+1F1EC"),
  createCountry("Marshall Islands", "MH", "🇲🇭", "U+1F1F2 U+1F1ED"),
  createCountry("North Macedonia", "MK", "🇲🇰", "U+1F1F2 U+1F1F0"),
  createCountry("Mali", "ML", "🇲🇱", "U+1F1F2 U+1F1F1"),
  createCountry("Myanmar (Burma)", "MM", "🇲🇲", "U+1F1F2 U+1F1F2"),
  createCountry("Mongolia", "MN", "🇲🇳", "U+1F1F2 U+1F1F3"),
  createCountry("Macao SAR China", "MO", "🇲🇴", "U+1F1F2 U+1F1F4"),
  createCountry("Northern Mariana Islands", "MP", "🇲🇵", "U+1F1F2 U+1F1F5"),
  createCountry("Martinique", "MQ", "🇲🇶", "U+1F1F2 U+1F1F6"),
  createCountry("Mauritania", "MR", "🇲🇷", "U+1F1F2 U+1F1F7"),
  createCountry("Montserrat", "MS", "🇲🇸", "U+1F1F2 U+1F1F8"),
  createCountry("Malta", "MT", "🇲🇹", "U+1F1F2 U+1F1F9"),
  createCountry("Mauritius", "MU", "🇲🇺", "U+1F1F2 U+1F1FA"),
  createCountry("Maldives", "MV", "🇲🇻", "U+1F1F2 U+1F1FB"),
  createCountry("Malawi", "MW", "🇲🇼", "U+1F1F2 U+1F1FC"),
  createCountry("Mexico", "MX", "🇲🇽", "U+1F1F2 U+1F1FD"),
  createCountry("Malaysia", "MY", "🇲🇾", "U+1F1F2 U+1F1FE"),
  createCountry("Mozambique", "MZ", "🇲🇿", "U+1F1F2 U+1F1FF"),
  createCountry("Namibia", "NA", "🇳🇦", "U+1F1F3 U+1F1E6"),
  createCountry("New Caledonia", "NC", "🇳🇨", "U+1F1F3 U+1F1E8"),
  createCountry("Niger", "NE", "🇳🇪", "U+1F1F3 U+1F1EA"),
  createCountry("Norfolk Island", "NF", "🇳🇫", "U+1F1F3 U+1F1EB"),
  createCountry("Nigeria", "NG", "🇳🇬", "U+1F1F3 U+1F1EC"),
  createCountry("Nicaragua", "NI", "🇳🇮", "U+1F1F3 U+1F1EE"),
  createCountry("Netherlands", "NL", "🇳🇱", "U+1F1F3 U+1F1F1"),
  createCountry("Norway", "NO", "🇳🇴", "U+1F1F3 U+1F1F4"),
  createCountry("Nepal", "NP", "🇳🇵", "U+1F1F3 U+1F1F5"),
  createCountry("Nauru", "NR", "🇳🇷", "U+1F1F3 U+1F1F7"),
  createCountry("Niue", "NU", "🇳🇺", "U+1F1F3 U+1F1FA"),
  createCountry("New Zealand", "NZ", "🇳🇿", "U+1F1F3 U+1F1FF"),
  createCountry("Oman", "OM", "🇴🇲", "U+1F1F4 U+1F1F2"),
  createCountry("Panama", "PA", "🇵🇦", "U+1F1F5 U+1F1E6"),
  createCountry("Peru", "PE", "🇵🇪", "U+1F1F5 U+1F1EA"),
  createCountry("French Polynesia", "PF", "🇵🇫", "U+1F1F5 U+1F1EB"),
  createCountry("Papua New Guinea", "PG", "🇵🇬", "U+1F1F5 U+1F1EC"),
  createCountry("Philippines", "PH", "🇵🇭", "U+1F1F5 U+1F1ED"),
  createCountry("Pakistan", "PK", "🇵🇰", "U+1F1F5 U+1F1F0"),
  createCountry("Poland", "PL", "🇵🇱", "U+1F1F5 U+1F1F1"),
  createCountry("St. Pierre & Miquelon", "PM", "🇵🇲", "U+1F1F5 U+1F1F2"),
  createCountry("Pitcairn Islands", "PN", "🇵🇳", "U+1F1F5 U+1F1F3"),
  createCountry("Puerto Rico", "PR", "🇵🇷", "U+1F1F5 U+1F1F7"),
  createCountry("Palestinian Territories", "PS", "🇵🇸", "U+1F1F5 U+1F1F8"),
  createCountry("Portugal", "PT", "🇵🇹", "U+1F1F5 U+1F1F9"),
  createCountry("Palau", "PW", "🇵🇼", "U+1F1F5 U+1F1FC"),
  createCountry("Paraguay", "PY", "🇵🇾", "U+1F1F5 U+1F1FE"),
  createCountry("Qatar", "QA", "🇶🇦", "U+1F1F6 U+1F1E6"),
  createCountry("Réunion", "RE", "🇷🇪", "U+1F1F7 U+1F1EA"),
  createCountry("Romania", "RO", "🇷🇴", "U+1F1F7 U+1F1F4"),
  createCountry("Serbia", "RS", "🇷🇸", "U+1F1F7 U+1F1F8"),
  createCountry("Russia", "RU", "🇷🇺", "U+1F1F7 U+1F1FA"),
  createCountry("Rwanda", "RW", "🇷🇼", "U+1F1F7 U+1F1FC"),
  createCountry("Saudi Arabia", "SA", "🇸🇦", "U+1F1F8 U+1F1E6"),
  createCountry("Solomon Islands", "SB", "🇸🇧", "U+1F1F8 U+1F1E7"),
  createCountry("Seychelles", "SC", "🇸🇨", "U+1F1F8 U+1F1E8"),
  createCountry("Sudan", "SD", "🇸🇩", "U+1F1F8 U+1F1E9"),
  createCountry("Sweden", "SE", "🇸🇪", "U+1F1F8 U+1F1EA"),
  createCountry("Singapore", "SG", "🇸🇬", "U+1F1F8 U+1F1EC"),
  createCountry("St. Helena", "SH", "🇸🇭", "U+1F1F8 U+1F1ED"),
  createCountry("Slovenia", "SI", "🇸🇮", "U+1F1F8 U+1F1EE"),
  createCountry("Svalbard & Jan Mayen", "SJ", "🇸🇯", "U+1F1F8 U+1F1EF"),
  createCountry("Slovakia", "SK", "🇸🇰", "U+1F1F8 U+1F1F0"),
  createCountry("Sierra Leone", "SL", "🇸🇱", "U+1F1F8 U+1F1F1"),
  createCountry("San Marino", "SM", "🇸🇲", "U+1F1F8 U+1F1F2"),
  createCountry("Senegal", "SN", "🇸🇳", "U+1F1F8 U+1F1F3"),
  createCountry("Somalia", "SO", "🇸🇴", "U+1F1F8 U+1F1F4"),
  createCountry("Suriname", "SR", "🇸🇷", "U+1F1F8 U+1F1F7"),
  createCountry("South Sudan", "SS", "🇸🇸", "U+1F1F8 U+1F1F8"),
  createCountry("São Tomé & Príncipe", "ST", "🇸🇹", "U+1F1F8 U+1F1F9"),
  createCountry("El Salvador", "SV", "🇸🇻", "U+1F1F8 U+1F1FB"),
  createCountry("Sint Maarten", "SX", "🇸🇽", "U+1F1F8 U+1F1FD"),
  createCountry("Syria", "SY", "🇸🇾", "U+1F1F8 U+1F1FE"),
  createCountry("Eswatini", "SZ", "🇸🇿", "U+1F1F8 U+1F1FF"),
  createCountry("Tristan da Cunha", "TA", "🇹🇦", "U+1F1F9 U+1F1E6"),
  createCountry("Turks & Caicos Islands", "TC", "🇹🇨", "U+1F1F9 U+1F1E8"),
  createCountry("Chad", "TD", "🇹🇩", "U+1F1F9 U+1F1E9"),
  createCountry("French Southern Territories", "TF", "🇹🇫", "U+1F1F9 U+1F1EB"),
  createCountry("Togo", "TG", "🇹🇬", "U+1F1F9 U+1F1EC"),
  createCountry("Thailand", "TH", "🇹🇭", "U+1F1F9 U+1F1ED"),
  createCountry("Tajikistan", "TJ", "🇹🇯", "U+1F1F9 U+1F1EF"),
  createCountry("Tokelau", "TK", "🇹🇰", "U+1F1F9 U+1F1F0"),
  createCountry("Timor-Leste", "TL", "🇹🇱", "U+1F1F9 U+1F1F1"),
  createCountry("Turkmenistan", "TM", "🇹🇲", "U+1F1F9 U+1F1F2"),
  createCountry("Tunisia", "TN", "🇹🇳", "U+1F1F9 U+1F1F3"),
  createCountry("Tonga", "TO", "🇹🇴", "U+1F1F9 U+1F1F4"),
  createCountry("Turkey", "TR", "🇹🇷", "U+1F1F9 U+1F1F7"),
  createCountry("Trinidad & Tobago", "TT", "🇹🇹", "U+1F1F9 U+1F1F9"),
  createCountry("Tuvalu", "TV", "🇹🇻", "U+1F1F9 U+1F1FB"),
  createCountry("Taiwan", "TW", "🇹🇼", "U+1F1F9 U+1F1FC"),
  createCountry("Tanzania", "TZ", "🇹🇿", "U+1F1F9 U+1F1FF"),
  createCountry("Ukraine", "UA", "🇺🇦", "U+1F1FA U+1F1E6"),
  createCountry("Uganda", "UG", "🇺🇬", "U+1F1FA U+1F1EC"),
  createCountry("U.S. Outlying Islands", "UM", "🇺🇲", "U+1F1FA U+1F1F2"),
  createCountry("United Nations", "UN", "🇺🇳", "U+1F1FA U+1F1F3"),
  createCountry("United States", "US", "🇺🇸", "U+1F1FA U+1F1F8"),
  createCountry("Uruguay", "UY", "🇺🇾", "U+1F1FA U+1F1FE"),
  createCountry("Uzbekistan", "UZ", "🇺🇿", "U+1F1FA U+1F1FF"),
  createCountry("Vatican City", "VA", "🇻🇦", "U+1F1FB U+1F1E6"),
  createCountry("St. Vincent & Grenadines", "VC", "🇻🇨", "U+1F1FB U+1F1E8"),
  createCountry("Venezuela", "VE", "🇻🇪", "U+1F1FB U+1F1EA"),
  createCountry("British Virgin Islands", "VG", "🇻🇬", "U+1F1FB U+1F1EC"),
  createCountry("U.S. Virgin Islands", "VI", "🇻🇮", "U+1F1FB U+1F1EE"),
  createCountry("Vietnam", "VN", "🇻🇳", "U+1F1FB U+1F1F3"),
  createCountry("Vanuatu", "VU", "🇻🇺", "U+1F1FB U+1F1FA"),
  createCountry("Wallis & Futuna", "WF", "🇼🇫", "U+1F1FC U+1F1EB"),
  createCountry("Samoa", "WS", "🇼🇸", "U+1F1FC U+1F1F8"),
  createCountry("Kosovo", "XK", "🇽🇰", "U+1F1FD U+1F1F0"),
  createCountry("Yemen", "YE", "🇾🇪", "U+1F1FE U+1F1EA"),
  createCountry("Mayotte", "YT", "🇾🇹", "U+1F1FE U+1F1F9"),
  createCountry("South Africa", "ZA", "🇿🇦", "U+1F1FF U+1F1E6"),
  createCountry("Zambia", "ZM", "🇿🇲", "U+1F1FF U+1F1F2"),
  createCountry("Zimbabwe", "ZW", "🇿🇼", "U+1F1FF U+1F1FC"),
  createCountry(
    "England",
    "ENGLAND",
    "🏴",
    "U+1F3F4 U+E0067 U+E0062 U+E0065 U+E006E U+E0067 U+E007F"
  ),
  createCountry(
    "Scotland",
    "SCOTLAND",
    "🏴",
    "U+1F3F4 U+E0067 U+E0062 U+E0073 U+E0063 U+E0074 U+E007F"
  ),
  createCountry(
    "Wales",
    "WALES",
    "🏴",
    "U+1F3F4 U+E0067 U+E0062 U+E0077 U+E006C U+E0073 U+E007F"
  ),
];
